export default __webpack_public_path__ + "navigation-examples-custom-banner-v1-960-cce2436f69b1495d2d402ad81a370a8d.webp";